// MNT-014: shared error humanizer for the observability pages
// (Annotations / Datasets / Evals / Prompts).
//
// The 412 (not provisioned) and 503 (unavailable) messages are identical
// across all callers, so they live here. Callers pass per-page overrides
// for the status codes whose copy differs (500/403/404), preserving each
// page's exact original behavior.
//
// @param {*}      e               the caught error (may carry `.status`)
// @param {object} statusMessages  status → message overrides for this caller
export function humanizeError(e, statusMessages = {}) {
  if (!e) return "Unknown error";
  const messages = {
    412: "Langfuse not provisioned for this tenant.",
    503: "Langfuse temporarily unavailable.",
    ...statusMessages,
  };
  if (e.status != null && messages[e.status]) return messages[e.status];
  return e.message || String(e);
}
